/* Fix Search 194325 */
const searchTerm = window.location.search;
if (searchTerm.length > 5 && searchTerm.indexOf('type=product&') !== -1) {
  let newSearchTerm = '?q=' + searchTerm.replace(/\+/g,'%20').split('q=')[1];
  let newUrl = window.location.href.replace(searchTerm, newSearchTerm)
  window.location.replace(newUrl);
}
/* End Fix Search 194325 */